module.exports = __webpack_public_path__ + "static/media/_ellipsis.347702b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_ellipsis.jpg
// module id = 64
// module chunks = 0